









































import Vue from 'vue';
import Highcharts from 'highcharts';
import TextReadabilityChart from '@/components/TextView/TextReadabilityChart.vue';
import dataset from '@/utils/dataset';
import format from '@/utils/format';
import functions from '@/utils/functions';
import { mapActions, mapState } from 'vuex';
import { TextState } from '@/utils/types/store';

const { ifPresent } = functions;

export default Vue.extend({
  name: 'TextView',
  components: {
    TextReadabilityChart,
  },
  data() {
    return {
      textLoaded: false,
      readabilityLoaded: false,
      smoothing: 1,
      tooltipFormatter: (function formatter(): string | void {
        return ifPresent(format.formatReadabilityScore)(this.y);
      }) as Highcharts.FormatterCallbackFunction<Highcharts.Point>,
    };
  },
  computed: {
    ...mapState('text', {
      text: (state) => (state as TextState).text,
      paragraph: (state) => (state as TextState).paragraph,
      textReadability: (state) => (state as TextState).textReadability,
    }),
    options(): object {
      if (!this.textReadability.textId) {
        return {};
      }

      const {
        paragraphReadabilities,
      } = this.textReadability;

      const smooth = (data: number[]) => (
        this.smoothing === 1
          ? data
          : Array.from(
            dataset.simpleMovingAverage(Math.ceil(this.smoothing))(data),
          )
      );

      return {
        series: [{
          name: 'Flesch reading ease',
          data: smooth(paragraphReadabilities.map((pr) => pr.fleschReadingEase)),
          tooltip: { pointFormatter: this.tooltipFormatter },
        }, {
          name: 'Flesch–Kincaid grade level',
          data: smooth(paragraphReadabilities.map((pr) => pr.fleschKincaidGradeLevel)),
          tooltip: { pointFormatter: this.tooltipFormatter },
        }],
      } as Highcharts.Options;
    },
    maxSmoothing(): number {
      return Math.max(
        1,
        this.textReadability.paragraphReadabilities.length / 10,
      );
    },
  },
  methods: {
    ...mapActions('text', ['loadText', 'loadTextReadability', 'loadParagraph']),
    pointSelected(n: number) {
      this.loadParagraph({
        docId: this.text.id,
        paragraphNumber: n,
      });
    },
  },
  async mounted() {
    const { id } = this.$route.params;
    this.loadText(id).then(() => {
      this.textLoaded = true;
    });
    this.loadTextReadability(id).then(() => {
      this.readabilityLoaded = true;
    });
  },
});
